<template>
  <div class="course_status">
    <template v-if="courseStatus === -1">

      <template v-if="courseIndex">
        <div class="learning_time_range_time end_status">
          <div class="range_body">{{ course.s_time }}&nbsp;-&nbsp;{{ course.e_time }}</div>
        </div>
      </template>
      <template v-else>
        <div class="learning_time_range_date end_status">
          <div class="range_head" style="font-size: 1rem">{{ course.date }}</div>
          <div class="range_body"  style="font-size: 1rem">{{ course.s_time }}&nbsp;-&nbsp;{{ course.e_time }}</div>
        </div>
      </template>

    </template>
    <template v-else-if="courseStatus === 2">
      <template v-if="courseIndex">
        <div class="learning_time_range_time not_start">
          <div class="range_body">{{ course.s_time }}&nbsp;-&nbsp;{{ course.e_time }}</div>
        </div>
      </template>
      <template v-else>
        <div class="learning_time_range_date not_start">
          <div class="range_head">{{ course.date }}</div>
          <div class="range_body">{{ course.s_time }}&nbsp;-&nbsp;{{ course.e_time }}</div>
        </div>
      </template>
    </template>
    <template v-else-if="courseStatus === 1">


      <template v-if="courseIndex">
        <div class="learning_time_range_time ready_start">
          <div class="range_body">{{ course.s_time }}&nbsp;-&nbsp;{{ course.e_time }}</div>
        </div>
      </template>
      <template v-else>
        <div class="learning_time_range_date ready_start">
          <div class="range_head">{{ course.date }}</div>
          <div class="range_body">{{ course.s_time }}&nbsp;-&nbsp;{{ course.e_time }}</div>
        </div>
      </template>


    </template>
    <template v-else-if="courseStatus === 0">

      <template v-if="courseIndex">
        <div class="learning_time_range_time new_start">
          <div class="range_body">{{ course.s_time }}&nbsp;-&nbsp;{{ course.e_time }}</div>
        </div>
      </template>
      <template v-else>
        <div class="learning_time_range_date new_start">
          <div class="range_head">{{ course.date }}</div>
          <div class="range_body">{{ course.s_time }}&nbsp;-&nbsp;{{ course.e_time }}</div>
        </div>
      </template>

    </template>
    <template v-else-if="courseStatus === 3">

      <template v-if="courseIndex">
        <div class="learning_time_range_time timeout">
          <div class="range_body">{{ course.s_time }}&nbsp;-&nbsp;{{ course.e_time }}</div>
        </div>
      </template>
      <template v-else>
        <div class="learning_time_range_date timeout">
          <div class="range_head">{{ course.date }}</div>
          <div class="range_body">{{ course.s_time }}&nbsp;-&nbsp;{{ course.e_time }}</div>
        </div>
      </template>


    </template>
  </div>
</template>

<script>
import { enterStatus } from '@/utils/format-tools'

export default {
  name: 'course_range',
  components: {},
  data () {
    return {
      timer: '',
      timecountdown: this.data.timecountdown,
      course: this.data,
      courseIndex: this.index
    }
  },
  props: ['data', 'index'],
  computed: {
    courseStatus: function () {
      const { s_time, e_time } = this.data
      const { pre_in_class, after_in_class } = this.data.config || { pre_in_class: 0, after_in_class: 0 }
      return enterStatus({
        timecountdown: this.timecountdown,
        pre_in_class,
        after_in_class,
        s_time,
        e_time
      })
    }
  },
  watch: {},
  methods: {
    enterInterval (data) {
      this.timecountdown--
      if (this.timecountdown < 0) {
        clearInterval(this.timer)
      }
    }
  },
  created () {
  },
  mounted () {
    this.timer = setInterval(this.enterInterval, 1000)
  },
  beforeCreate () {
  },
  beforeMount () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  destroyed () {
  },
  activated () {
  }
}
</script>
<style lang="less" scoped>


.learning_time_range_time {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  color: #fff;
  position: absolute;
  left: 2rem;
  top: 2rem;
  width: 180px;
  padding: 0 1rem 0 2rem;
  font-size: 1.3rem;
  line-height: 40px;
  height: 40px;
  background: linear-gradient(90deg, #32BE88, #66D3A9);
  border-radius: 4px;

  &:after {
    display: block;
    content: " ";
    position: absolute;
    top: 50%;
    left: 1rem;
    height: 6px;
    width: 6px;
    margin-top: -3px;
    background: #fff;
    border-radius: 100%;
  }

  img {
    width: 100%;
  }


  &.end_status {
    opacity: 0.5;
  }

  &.not_start {
    opacity: 0.5;
  }

  &.timeout {
    opacity: 0.5;
  }


  &.ready_start {

  }

  &.new_start {
  }

}

.learning_time_range_date {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  padding: 0 1rem;
  color: #fff;
  position: absolute;
  left: -0.56rem;
  top: 2rem;
  width: 300px;
  padding-left: 2rem;
  font-size: 1.3rem;
  line-height: 40px;
  height: 50px;
  background-image: url("~assets/index_v2/icon_kebiao_jrbg.png");
  background-size: 100% 100%;
  background-attachment: inherit;
  background-repeat: no-repeat;



  &.end_status {
    background-image: url("~assets/index_v2/icon_kebiao_jrbg.png");
  }

  &.not_start {
    background-image: url("~assets/index_v2/icon_kebiao_trbg.png");
  }

  &.timeout {
    background-image: url("~assets/index_v2/icon_kebiao_trbg.png");
  }


  &.ready_start {

  }

  &.new_start {
  }

  img {
    width: 100%;
  }
}
</style>
